import { Controller } from "@hotwired/stimulus"

// Submits the form as soon as one of its controls changes. Used by the switch
// in ResourceToggleComponent, whose form has no submit button at all — the
// checkbox is the whole control.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
